import Swal from "sweetalert2";

export const handleError = (error) => {
    let errorMessage = 'An unexpected error occurred while fetching user.';
    if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
    } else if (error.message) {
        errorMessage = error.message;
    }
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
        didOpen: () => { document.querySelector('.swal2-container').style.zIndex = '9999'; },
    });
};